import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import CountDown from '@/components/countdown/index.vue';
import BackTop from '@/common/backtop.vue';
// import {
//   aliPayPc, orderDetail, pageVisit, getDataCard,
//   getDataBanner,
//   getDataReCommend,
//   getDataProType
// } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    // 活动结束倒计时5s
    _this.countdown = 5;
    _this.timer = '';
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      // this.goHomePage();
    }
  }, {
    key: "goHomePage",
    value: function goHomePage() {
      var _this2 = this;
      this.timer = setInterval(function () {
        _this2.countdown -= 1;
        if (_this2.countdown === 0) {
          _this2.$router.push('/');
          clearInterval(_this2.timer);
        }
      }, 1000);
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Footer: Footer,
    CountDown: CountDown,
    BackTop: BackTop
  }
})], default_1);
export default default_1;